import { isDisabledFriday, enableVacations } from "@/configs/global.config";
import store from "../store";

export function dig(getterName, id, prop){
    var object = this[getterName](id);
    if (prop === 'cityName') {
        var array = object;
        return array.join(', ');
    }
    return object ? object[prop] : null;
}

export function getMaterialName(material, formName) {
    if (!material) return;

    var details = [
        formName,
        material.dose,
        material.strength
    ];

    return `${material.name} (${details.filter(c => c != null).join(' ')})`;
}

export function findClassification(workload){
    switch (workload){
        case 0: return 'A+';
        case 1: return 'A';
        case 2: return 'A-';
        case 3: return 'B+';
        case 4: return 'B';
        case 5: return 'B-';
        case 6: return 'C';
    }
}

export function downloadBlob(blob, fileName) {
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName || true;
	a.click();
	a.remove();
}

export const makeTree = (list) => {
	const findChildren = (id) => {
		return list
			.filter((e) => e.parentRoleId === id)
			.map((e) => ({
				...e,
				children: findChildren(e.id)
			}));
	};

	const arr = list
		.filter((e) => !e.parentRoleId)
		.map((e) => ({
			...e,
			children: findChildren(e.id)
		}));

	return arr;
}

export function transformData(input) {
    const transformNode = (node) => {
        const { root, children } = node;
        return {
            id: root.id, // استخدام معرف الدور أو توليد معرف فريد
            name: root.name,
            permissions: root.permissions, // يمكنك إضافة الأذونات إذا لزم الأمر
            children: children.map(transformNode) // تحويل الأبناء
        };
    };

    return input.map(transformNode);
}

function generateUniqueId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
              const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const disableDates = (date) => {
    const formattedDate = date;
    if (isDisabledFriday && enableVacations) {
        return !store.state.vacations.vacationsDayDetails.includes(formattedDate) && new Date(date).getDay() !== 5;
    } else if (enableVacations && !isDisabledFriday) {
        return !store.state.vacations.vacationsDayDetails.includes(formattedDate);
    } else if (isDisabledFriday && !enableVacations) {
        return new Date(date).getDay() !== 5
    } else {
        return new Date(date).getDay() !== -1
    }
}
